import { Component } from '@angular/core';
import type { ILoadingOverlayComp } from 'ag-grid-enterprise';

@Component({
  selector: 'app-grid-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  standalone: false,
})
export class GridLoadingOverlay implements ILoadingOverlayComp {
  params!: { message: string };

  agInit(params: any): void {
    this.params = params;
  }

  getGui(): HTMLElement {
    return '' as unknown as HTMLElement;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
}
